import { InputAdornment, TextField } from '@mui/material';
import DatePicker from 'react-datepicker';
import { CalendarMonth } from '@mui/icons-material';
import { useEffect, useState } from 'react';

function DateRangePicker({ label, onChange, defaultValue }: any) {
  // Initialize the state with [Date | undefined, Date | undefined] instead of [null, null]
  const [dateRange, setDateRange] = useState<[Date | undefined, Date | undefined]>([undefined, undefined]);
  const [startDate, endDate] = dateRange;

  // Whenever dateRange changes, call the parent onChange function
  //   useEffect(() => {
  //     if (onChange) {
  //       onChange(dateRange); // Pass the dateRange as [Date | undefined, Date | undefined]
  //     }
  //   }, [dateRange, onChange]); // Trigger onChange when dateRange changes

  // Handle the range change properly
  const handleDateChange = (dates: any) => {
    setDateRange(dates); // Update local state
    if (onChange) {
      onChange(dates); // Directly call onChange with the updated dateRange
    }
  };

  useEffect(() => {
    if (defaultValue?.length > 0) setDateRange(defaultValue);
  }, [defaultValue]);

  return (
    <DatePicker
      customInput={
        <TextField
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarMonth style={{ fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
          label={`${label}(Range)`}
          fullWidth
          size="small"
        />
      }
      onChange={handleDateChange} // Pass the updated handleDateChange function
      startDate={startDate} // Use startDate: Date | undefined
      endDate={endDate} // Use endDate: Date | undefined
      onCalendarClose={() => {
        if (!endDate && startDate) {
          setDateRange([startDate, startDate]);
        }
      }}
      shouldCloseOnSelect={false}
      dateFormat="MM/dd/yyyy"
      disabledKeyboardNavigation
      selectsRange
      selected={startDate} // Pass startDate: Date | undefined
      selectsDisabledDaysInRange
    />
  );
}

export default DateRangePicker;
